<template>
  <div id="critical-issue-form">
    <p id="critical-issue-intro"><b>
    This enquiry route should only be used for the below -<br>
    <ul>
        <li>Health and safety issues</li>
        <li>GDPR breaches</li>
        <li>Fraudulent activity</li>
    </ul>
    Any other enquiries submitted incorrectly via this route will be passed on to the appropriate team and will result in a delayed response.<br>
    Please can you give a brief description of what's happened?
    </b></p>
    <EmailFormInput />
    <p>Optionally upload 2 photos to support the issue. Please upload them here:</p>
    <input type="file" name="photo1" id="photo1">
    <input type="file" name="photo2" id="photo2">
    <SubmitButton btnText="Submit Enquiry" />
  </div>
</template>

<script>
import EmailFormInput from '../components/EmailFormInput'
import SubmitButton from '../components/SubmitButton'

export default {
  components: {
    EmailFormInput,
    SubmitButton
  }
}
</script>


// WEBPACK FOOTER //
// src/components/CriticalIssueForm.vue